import React from "react";
import styled from "styled-components";
import BaseComponent from "../../BaseComponent.js";
import NanoFlex from "../../Global/NanoFlex.js";
import Type from "../../Global/Typography.js";

const StyledAssessmentInRecruitment = styled(NanoFlex)`
  padding: 0 100px 0 100px;
  gap: 30px;
  height: auto;

  .assessmentRecruitTopicBlock {
    width: 40%;
  }

  .assessmentRecruitContentBlock {
    gap: 24px;
    width: 60%;
    height: auto;

    .title {
      h3 {
        font-weight: 500;
      }
    }

    .articleContent {
      gap: 16px;
      height: auto;

      p {
        color: ${(props) => props.theme.color.primaryColors.darkPurple};
        opacity: 0.7;
      }
    }
  }

  @media only screen and (max-width: 1450px) {
    padding: 0 50px 0 50px;
  }

  /* TABLETS */
  @media only screen and (max-width: 1024px) {
    padding: 0 30px 0 30px;
  }

  @media only screen and (max-width: 815px) {
    padding: 0 10px 0 10px;
    flex-direction: column;
    gap: 16px;

    .assessmentRecruitTopicBlock {
      display: none;
    }

    .assessmentRecruitTopicBlock,
    .assessmentRecruitContentBlock {
      width: 100%;
    }
  }
`;

export default class AssessmentInRecruitment extends BaseComponent {
  componentDidMount() {
    super.componentDidMount();
  }

  componentWillUnmount() {
    super.componentWillUnmount();
  }

  render() {
    return (
      <StyledAssessmentInRecruitment justifyContent={"flex-start"} alignItems={"flex-start"}>
        <NanoFlex className="assessmentRecruitTopicBlock" justifyContent="flex-start" alignItems="flex-start">
          <Type.p>{this.translation.assessment.assessmentInRecruitment}</Type.p>
        </NanoFlex>
        <NanoFlex className="assessmentRecruitContentBlock" flexDirection="column" justifyContent="flex-start" alignItems="flex-start">
          <NanoFlex className="title" justifyContent="flex-start">
            <Type.h3>{this.translation.assessment.developAndRetainPeople}</Type.h3>
          </NanoFlex>
          <NanoFlex className="articleContent" flexDirection="column" justifyContent="flex-start" alignItems="flex-start">
            <Type.p>{this.translation.assessment.assessmentInRecruitmentInfoOne}</Type.p>
            <Type.p>{this.translation.assessment.assessmentInRecruitmentInfoTwo}</Type.p>
          </NanoFlex>
        </NanoFlex>
      </StyledAssessmentInRecruitment>
    );
  }
}
